import ProfileCompletionBanner from "./components/ProfileCompletionBanner";
import DashboardMobileHeader from "./components/DashboardMobileHeader";
import AssignmentPendingBanner from "./components/AssignmentPendingBanner";
import ApplicationPendingBanner from "./components/ApplicationPendingBanner";
import CompleteAssignmentPopUp from "./components/CompleteAssignmentPopUp";
import AssignmentRejectionBanner from "./components/AssignmentRejectionBanner";
import ApplicationRejectionBanner from "./components/ApplicationRejectionBanner";
import IncompleteApplicationReminderBanner from "./components/IncompleteApplicationReminderBanner";
import { TUser } from "@/types/types";
import { useProfileCompletion } from "@/hooks/useProfileCompletion";
import ResetPasswordBanner from "./components/ResetPasswordBanner";
import ShipProduct from "./components/ShipProduct";
import { useGetReshippingDataQuery } from "@/redux/feature/productShipping/productShipping";
import { useCreatorStatus } from "@/hooks/useCreatorStatuts";
import { useGlobalContext } from "@/context/GlobalContext";
import { useState } from "react";
import CreatorTats from "./components/CreatorTats";
import AssignmentBanner from "./components/AssignmentBanner";
import { AvailabilityModal } from "../sameDayDelivery/AvailabilityModal";
import { useAppSelector } from "@/redux/hooks/hooks";
import SameDayAvailabilityCard from "../jobs/components/SameDayAvailabilityCard";
import BlurPopUp from "../jobs/components/BlurPopUp";

const Dashboard = () => {
  const { userData } = useGlobalContext();
  const [showSameDayDeliveryModal, setShowSameDayDeliveryModal] =
    useState(false);
  const userEmail = useAppSelector((state) => state?.auth?.user?.email);

  const handleConfirm = (data: any) => {
    console.log("Confirmed availability:", data);
  };

  const { data: getReshippingData, error } = useGetReshippingDataQuery(
    userData?.creator_id as string,
    {
      skip: !userData?.creator_id,
    },
  );

  const reshippingData = getReshippingData?.data[0];

  // Profile Completion status
  const { isProfileComplete } = useProfileCompletion(userData as TUser);

  const { isCreatorApproved, status, rejectedReasons, isLoading, isError } =
    useCreatorStatus(userData?.email);

  // Determine if a popup should be shown
  const shouldShowPopup = status?.isAppApprovedAwaitingAssignment;
  const shouldShowAssignmentReviewPopup = status?.isAssignmentPending;
  const shouldShowStatusPopup =
    shouldShowPopup || shouldShowAssignmentReviewPopup;

  // Show SameDayAvailabilityCard when:
  // - Creator is overwritten OR fully approved (all negative flags are false)
  // Hide when:
  // - Application is rejected OR assignment is rejected OR awaiting assignment OR not initiated OR pending
  const isFullyApproved =
    !status?.isApplicationPending &&
    !status?.isAssignmentPending &&
    !status?.isApplicationRejected &&
    !status?.isAssignmentRejected &&
    !status?.isAppApprovedAwaitingAssignment &&
    !status?.isNotInitiated;

  const shouldShowSameDayCard =
    userEmail &&
    !isLoading &&
    !isError &&
    !shouldShowPopup &&
    (status?.isOverwritten || isFullyApproved);

  console.log(status);
  const renderPopup = () => {
    if (shouldShowAssignmentReviewPopup) {
      return <BlurPopUp status={status} />;
    }

    if (status?.isAppApprovedAwaitingAssignment) {
      return <CompleteAssignmentPopUp />; // your existing popup
    }
    return null;
  };

  return (
    <div className="relative min-h-[85vh] pb-20">
      <div
        className={`px-4 md:px-11 pt-8 pb-10 ${
          shouldShowStatusPopup ? "filter blur-sm" : ""
        }`}
      >
        <div>
          <h1 className="text-base md:text-xl leading-5 tracking-[-1%] mb-2.5 font-medium">
            Dashboard
          </h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
          {shouldShowSameDayCard && <CreatorTats />}

          {shouldShowSameDayCard && (
            <SameDayAvailabilityCard
              setShowModifySlot={() => setShowSameDayDeliveryModal(true)}
            />
          )}
        </div>

        <div className="relative mt-6">
          {/* Conditionally render banners based on status */}

          {isLoading ? (
            <p className="py-20 flex justify-center items-center font-semibold animate-pulse">
              Loading...
            </p>
          ) : (
            <>
              {isError ? (
                <>
                  <p className="py-20 flex justify-center items-center font-semibold animate-pulse">
                    Some thing went wrong...
                  </p>
                </>
              ) : (
                <>
                  {userData?.needsPasswordChanged && <ResetPasswordBanner />}

                  {!reshippingData?.status?.isShipping_started &&
                    reshippingData?.status?.is_new_actor_assigned && (
                      <ShipProduct
                        creator_shipping_details={
                          reshippingData?.creator_shipping_details
                        }
                        id={reshippingData?._id}
                      />
                    )}

                  {status?.isNotInitiated && (
                    <IncompleteApplicationReminderBanner />
                  )}

                  {status?.isApplicationPending && <ApplicationPendingBanner />}

                  {status?.isOverwritten && (
                    <div className="mt-4">
                      <AssignmentBanner />
                    </div>
                  )}

                  {status?.isApplicationRejected && (
                    <ApplicationRejectionBanner
                      rejectedReason={rejectedReasons}
                    />
                  )}

                  {status?.isAssignmentRejected && (
                    <AssignmentRejectionBanner />
                  )}

                  {!isProfileComplete && (
                    <ProfileCompletionBanner data={userData as TUser} />
                  )}
                </>
              )}
            </>
          )}
        </div>

        {/* <div className="mt-4">
          <DashboardMobileHeader />
        </div> */}
      </div>

      {/* Popup layer */}
      {shouldShowStatusPopup && (
        <div className="absolute inset-0 z-40 top-[25%] flex justify-center h-fit">
          {renderPopup()}
        </div>
      )}
      <AvailabilityModal
        isOpen={showSameDayDeliveryModal}
        setOpen={setShowSameDayDeliveryModal}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default Dashboard;
